import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismTable,
  PrismTableCellsTdTitleAttribute,
} from '@mylighthouse/prism-ember';
import HotelStrategyTablesCellsTdStrategyBaserate from 'lumen/components/hotel/strategy/tables/cells/td-strategy-baserate';
import HotelStrategyTablesCellsTdStrategyHotel from 'lumen/components/hotel/strategy/tables/cells/td-strategy-hotel';
import {
  COLUMN_CONFIG,
  COLUMN_PROPERTIES,
  COLUMN_WIDTH,
  SUBTYPE_DELIMITER,
  TYPE_ID_POSITION,
} from 'lumen/utils/constants/rate-strategy-constants';

interface HotelStrategyTablesTableDetailPositionSignature {
  Args: {
    initialSorts: unknown;
    onTableSort: unknown;
    sortFunction: unknown;
  };
}

export default class HotelStrategyTablesTableDetailPosition extends Component<HotelStrategyTablesTableDetailPositionSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get columns() {
    const valuePathHotel = COLUMN_PROPERTIES.HOTELINFO;
    const valuePathRate = `${TYPE_ID_POSITION}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`;
    const valuePathRoomname = `${TYPE_ID_POSITION}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.ROOM_NAME}`;

    const columns = [
      {
        ...COLUMN_CONFIG.HOTELINFO,
        name: this.intl.t('general.hotels'),
        tdComponent: HotelStrategyTablesCellsTdStrategyHotel,
        valuePath: valuePathHotel,
      },
      {
        name: this.intl.t('rates.rate'),
        valuePath: valuePathRate,
        tdComponent: HotelStrategyTablesCellsTdStrategyBaserate,
        width: COLUMN_WIDTH.LARGE,
        hasRightBorder: true,
        textAlign: 'center',
        isRedirectDisabled: true, // No redirects from position modal
      },
      {
        name: this.intl.t('general.room_name'),
        valuePath: valuePathRoomname,
        displayValuePath: `${valuePathRoomname}.formattedValue`,
        tdComponent: PrismTableCellsTdTitleAttribute,
        tdClassNames: 'text-200--regular truncate',
        width: COLUMN_WIDTH.EXTRA_LARGE,
        hasRightBorder: true,
        textAlign: 'center',
        hasLineClampTwo: true,
      },
    ];

    return columns;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rows() {
    // @ts-expect-error: Incorrect type
    const rows = [];

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const positionData = [...this.args.positionDataPerHotelInfo.values()];

    positionData.forEach((rowData) => {
      const row = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        [COLUMN_PROPERTIES.HOTELINFO]: rowData[COLUMN_PROPERTIES.HOTELINFO],
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        [`${TYPE_ID_POSITION}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`]:
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rowData[TYPE_ID_POSITION][COLUMN_PROPERTIES.RATE],
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        [`${TYPE_ID_POSITION}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.ROOM_NAME}`]:
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rowData[TYPE_ID_POSITION][COLUMN_PROPERTIES.ROOM_NAME],
      };

      rows.push(row);
    });

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return rows;
  }

  <template>
    <PrismTable
      {{! @glint-expect-error: Incorrect type }}
      @columns={{this.columns}}
      @enableAutoSortsUpdate={{true}}
      @fillMode="first-column"
      {{! @glint-expect-error: Incorrect type }}
      @initialSorts={{@initialSorts}}
      {{! @glint-expect-error: Incorrect type }}
      @onTableSort={{@onTableSort}}
      @removeTableBorder={{true}}
      @rows={{this.rows}}
      {{! @glint-expect-error: Incorrect type }}
      @sortFunction={{@sortFunction}}
      @widthConstraint="eq-container"
    />
  </template>
}
